export enum AlignmentTypes {
	Default = 'default',
	Left = 'left',
	Right = 'right',
	Stretch = 'stretch'
}
export type Alignment = `${AlignmentTypes}`;
export const isAlignment = (alignment: Alignment): boolean => Object.values<string>(AlignmentTypes).includes(alignment);